var _path, _path2, _path3, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHatchbackDefault = function SvgHatchbackDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.8,
    d: "M12.859 14.083a.828.828 0 1 1-1.656 0 .828.828 0 0 1 1.656 0ZM35.734 14.083a.828.828 0 1 1-1.656 0 .828.828 0 0 1 1.656 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M28.644 6.959c-2.41-1.425-6.408-1.981-8.75-2.153-.6-.044-.976.594-.675 1.113l.89 1.534c.133.229.373.374.638.383 1.84.06 5.351.126 7.515.161.664.011.954-.7.382-1.038ZM17.327 5.382l.738 1.26a.777.777 0 0 1-.677 1.168 322 322 0 0 0-3.501.004c-.699.003-2.537-1.04-2.305-1.699.07-.197.319-.399.896-.613 1.052-.39 3.015-.474 4.166-.502a.77.77 0 0 1 .683.382Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeLinecap: "round",
    strokeWidth: 0.774,
    d: "m9.715 14.832-2.087-1.694a1.95 1.95 0 0 1-.72-1.512v0a.65.65 0 0 1 .161-.428l.47-.535a.77.77 0 0 0 .191-.47l.104-1.933a.74.74 0 0 1 .112-.355c.354-.561 1.589-2.442 2.898-3.486a.6.6 0 0 1 .189-.103c1.24-.39 7.25-1.146 11.923-.481 3.618.514 5.543 1.592 10.053 3.98q.09.048.19.07c2.3.527 4.048.778 7.41 2.135a.6.6 0 0 1 .248.177c.326.418 1.183 1.81.223 3.584a.71.71 0 0 1-.485.348l-3.38.703m-22.857-.063 9.118.063h9.096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E242F",
    strokeWidth: 0.774,
    d: "M14.24 14.084a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.905,
    cy: 14.084,
    r: 2.21,
    stroke: "#1E242F",
    strokeWidth: 0.774
  })));
};
export default SvgHatchbackDefault;